import { render } from "./SlideCreatePassword.vue?vue&type=template&id=0396d722"
import script from "./SlideCreatePassword.vue?vue&type=script&lang=js"
export * from "./SlideCreatePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__